<template>
  <section class="benchmark-bar-group">
    <page-sub-header :title="title" class="mt-4" />
    <sme-card>
      <app-loading v-if="loading" />
      <template v-else>
        <p v-if="hasSubtitle" class="mb-3 text-muted">
          <slot name="subtitle" />
        </p>
        <div v-for="group in visibleGroups" :key="group.name" class="benchmark-bar-group__section">
          <h6 class="benchmark-bar-group__group-name">{{ group.name }}</h6>
          <benchmark-bar-metric
            v-for="metric in group.metrics"
            :key="metric.id"
            :label="metric.label"
            :description="metric.description"
            :tooltip-id="metric.tooltipId"
            :value="metric.value"
            :average="metric.average"
            :max-value="metric.maxValue"
            :formatted-value="metric.formattedValue"
            :formatted-average="metric.formattedAverage"
            :delta-formatted="metric.deltaFormatted"
            :delta-color-class="metric.deltaColorClass"
            :average-label="metric.averageLabel || 'Sector avg'"
          />
        </div>
      </template>
    </sme-card>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import AppLoading from '@/components/AppLoading.vue';
import PageSubHeader from '@/components/PageSubHeader.vue';
import SmeCard from '@/components/atoms/SmeCard.vue';
import { hasMeaningfulValue } from '@/pages/analyticsBenchmark/benchmarkUtils';
import BenchmarkBarMetric from '@/pages/analyticsBenchmark/components/BenchmarkBarMetric.vue';

const props = defineProps({
  title: { type: String, required: true },
  hasSubtitle: { type: Boolean, default: false },
  groups: { type: Array, required: true },
  loading: { type: Boolean, default: false },
});

const visibleGroups = computed(() =>
  props.groups
    .map(group => ({
      ...group,
      metrics: group.metrics.filter(metric => hasMeaningfulValue(metric.value)),
    }))
    .filter(group => group.metrics.length > 0),
);
</script>

<style lang="scss" scoped>
.benchmark-bar-group {
  &__section {
    & + & {
      margin-top: 1.5rem;
      padding-top: 1rem;
      border-top: 1px solid var(--palette-color-default-lighten-90);
    }
  }

  &__group-name {
    font-weight: 700;
    font-size: 1.15rem;
    color: var(--palette-color-default);
    margin-bottom: 0.25rem;
  }
}
</style>
